<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="60%" :mask-closable="false" :closable="false">
			<Row style="height: 35%;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						{{$tt('电压曲线')}}
					</p>
					<div class="echartDiv" id="echart111"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						{{$tt('电流曲线')}}
					</p>
					<div class="echartDiv" id="echart222"></div>
				</Card>
				</Col>
			</Row>
			<Row style="height: 35%;" :gutter="16">
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						{{$tt('SOC曲线')}}
					</p>
					<div class="echartDiv" id="echart333"></div>
				</Card>
				</Col>
				<Col span=12>
				<Card class="cardStyle">
					<p slot="title">
						<Icon type="ios-film-outline"></Icon>
						{{$tt('电枪温度曲线')}}
					</p>
					<div class="echartDiv" id="echart444"></div>
				</Card>
				</Col>
			</Row>
			<div slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{$tt('取消')}}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import echart from '../../../../js/echarts_hot.js'
	import webapi from '../../../../webapi.js'
	export default {
		data() {
			return {
				modal: {
					Title: this.$tt('充电曲线'),
					type: "add",
					ifShow: false,
					canInput: false
				},
				lineEchart: {
					legend_data: ['电压曲线'],
					seriesData: [{
						name: '电压曲线',
						type: 'line',
						stack: '电压曲线',
						data: [0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "black"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				//图表数据充电次数
				lineEchart2: {
					legend_data: ['电流曲线'],
					seriesData: [{
						name: '电流曲线',
						type: 'line',
						stack: '电流曲线',
						data: [0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "black"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				//图表数据充电次数
				lineEchart3: {
					legend_data: ['SOC曲线'],
					seriesData: [{
						name: 'SOC曲线',
						type: 'line',
						stack: 'SOC曲线',
						data: [0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "black"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				//图表数据充电次数
				lineEchart4: {
					legend_data: ['枪温度'],
					seriesData: [{
						name: '枪温度',
						type: 'line',
						stack: '枪温度',
						data: [0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "black"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				}
			};
		},
		mounted() {
		},
		methods: {
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.lineEchart.seriesData[0].data = [0, 0, 0, 0, 0, 0, 0]
						_this.lineEchart2.seriesData[0].data = [0, 0, 0, 0, 0, 0, 0]
						_this.lineEchart3.seriesData[0].data = [0, 0, 0, 0, 0, 0, 0]
						_this.lineEchart4.seriesData[0].data = [0, 0, 0, 0, 0, 0, 0]
						// echart.initLinechart3("echart11", _this.lineEchart);
						// echart.initLinechart3("echart22", _this.lineEchart2);
						// echart.initLinechart3("echart33", _this.lineEchart3);
						// echart.initLinechart3("echart44", _this.lineEchart4);
						echart.disposeEchart(null)
						_this.modal.ifShow = false
						break;
					default:
						break;
				}
			},
			show: function(type, params) {
				const _this = this;
				if (type == "ChargingCurves") {
					_this.modal.Title = this.$tt('订单曲线');
					_this.modal.type = "view";
					//解决刷新页面有时会忽略侧边栏宽度，图表超出容器
					_this.getChargingCurves(params)
				}
				_this.modal.ifShow = true
				setTimeout(() => {
					echart.initLinechart3("echart111", _this.lineEchart);
					echart.initLinechart3("echart222", _this.lineEchart2);
					echart.initLinechart3("echart333", _this.lineEchart3);
					echart.initLinechart3("echart444", _this.lineEchart4);
				}, 20)
			},
			getChargingCurves: function(OrderNo) {
				const _this = this
				console.log(OrderNo)
				let parms = {
					OrderNo: OrderNo,
				};
				_this.$axios.post(webapi.base_api_url + "/Operations/GetChargingCurves", parms, {
				}).then(res => {
					console.log("实时充电-充电曲线res")
					console.log(res.data)
					if (res.data.Code == 0) {
						let MyTimePoins = []
						res.data.Data.Curves.ReportTime.forEach(function(time) {
							//MyTimePoins.push(time.split(" ")[0])
							MyTimePoins.push(time)
						})
						_this.lineEchart.TimePoins = MyTimePoins;
						_this.lineEchart2.TimePoins = MyTimePoins;
						_this.lineEchart3.TimePoins = MyTimePoins;
						_this.lineEchart4.TimePoins = MyTimePoins;
						_this.lineEchart.seriesData[0].data = res.data.Data.Curves.VoltageCurve;
						_this.lineEchart2.seriesData[0].data = res.data.Data.Curves.CurrentCurve;
						_this.lineEchart3.seriesData[0].data = res.data.Data.Curves.SocCurve;
						_this.lineEchart4.seriesData[0].data = res.data.Data.Curves.TempConnectorCurve;

						console.log("实时充电重新渲染");
						echart.upEchartOpt(null);
						// echart.initLinechart3("echart111", _this.lineEchart);
						// echart.initLinechart3("echart222", _this.lineEchart2);
						// echart.initLinechart3("echart333", _this.lineEchart3);
						// echart.initLinechart3("echart444", _this.lineEchart4);
					}
				})
			}
		},
		destroyed() {
			echart.disposeEchart(null)
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
	.cardStyle {
		margin-bottom: 20px !important;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 100% !important;
		color: #000000;
		background-color: #ffffff !important;
	}

	.cardStyle p {
		text-align: left;
		color: #000000;
	}

	.cardStyle .echartDiv {
		height: 200px;
	}

	.echartDiv {
		background-color: #ffffff;
	}
</style>
